import styled from '@emotion/styled'

const Subtitle = styled.p`
  color: ${props => props.theme.colors.secondaryLabel};
  ${props => props.theme.typography.smallTitle}
  margin: 0rem 0.5rem;
`

export default Subtitle
